import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f53cd53a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collection-add-block p-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_3 = { class: "mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.create())),
          tabindex: "0"
        }, [
          _hoisted_2,
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("collection.create-new-collection")), 1)
        ]))
      : (_openBlock(), _createBlock(_component_Spinner, {
          key: 1,
          size: "md"
        }))
  ]))
}